// Italian translations - Primary language
export const it = {
  // Navigation
  nav: {
    products: 'Prodotti',
    sampleGalleries: 'Gallerie di campioni',
    resources: 'Risorse',
    pricing: 'Prezzi',
    startFree: 'INIZIA GRATIS',
    login: 'Accesso',
    lang: 'IT',
  },
  
  // Products dropdown
  productsMenu: [
    { label: 'Gallerie Clienti', href: '#galleries' },
    { label: 'Negozio di Stampe', href: '#store' },
    { label: 'Automazioni di Marketing', href: '#automation' },
    { label: 'Slideshow', href: '#slideshows' },
    { label: 'Blog', href: '#blogs' },
    { label: 'Consegna Video', href: '#video' },
    { label: 'Ricerca AI', href: '#ai-search' },
    { label: 'Rete Fornitori', href: '#vendor' },
  ],
  
  // Resources dropdown
  resourcesMenu: [
    { label: 'Blog Pic-Time', href: '#' },
    { label: 'Migrazione Galleria', href: '#migration' },
    { label: 'Sistema di Vendita Semplice', href: '#' },
    { label: 'Programma Affiliato', href: '#' },
    { label: 'Centro Assistenza', href: '#' },
    { label: 'Hub degli Esperti', href: '#' },
    { label: 'Webinar', href: '#' },
  ],
  
  // Hero section
  hero: {
    title: 'Eleva la tua Fotografia',
    titleLine2: 'per un\'attività di successo',
    features: ['Gallerie', 'Negozio di Stampe', 'Automazioni di Marketing', 'Slideshow', 'Blog', 'Ricerca AI'],
    cta: 'INIZIA GRATIS',
  },
  
  // Client Galleries section
  clientGalleries: {
    title: 'Gallerie Clienti',
    subtitle: 'Il tuo brand merita il meglio',
    tryNow: 'Prova ora',
    slides: [
      {
        title: 'Estetica Eccezionale',
        description: 'Bellissime gallerie clienti per presentare, condividere e vendere le tue immagini. Crea il viaggio dei tuoi clienti con griglie fotografiche uniche, che danno un tocco di classe alla tua narrazione e migliorano l\'esperienza del tuo brand online.',
      },
      {
        title: 'Video & GIF',
        description: 'Aggiungi un\'altra dimensione alle tue gallerie con l\'integrazione di video e GIF. I video possono essere aggiunti come scena e le GIF possono essere caricate nella galleria e persino impostate come copertina.',
      },
      {
        title: 'Nella tua lingua',
        description: 'Pic-Time offre una varietà di lingue, tutte riviste da fotografi locali. Rendi le tue gallerie familiari per i clienti modificando la lingua predefinita per i singoli progetti.',
      },
      {
        title: 'Portfolio',
        description: 'I clienti possono accedere direttamente alle loro gallerie, mentre i visitatori hanno accesso alle gallerie pubbliche o selezionate. Le pagine del portfolio sono completamente personalizzabili e possono essere facilmente integrate nel tuo sito.',
      },
      {
        title: 'Mobile',
        description: 'Le funzioni che ami, su ogni dispositivo. Con un caricamento rapido anche per le gallerie più grandi, i clienti possono facilmente condividere, acquistare e scaricare immagini al volo.',
      },
    ],
  },
  
  // Video Delivery section
  videoDelivery: {
    title: 'Consegna Video',
    description: 'Carica video fino a 90 minuti in HD o 4K, crea un\'esperienza di galleria coinvolgente con brevi clip accanto alle tue foto, offri contenuti pronti per i social media in una scena dedicata e aumenta lo spazio video man mano che la tua attività cresce.',
    cta: 'Esplora Consegna Video',
    clickForSound: 'Clicca per l\'audio',
  },
  
  // Vendor Network section
  vendorNetwork: {
    title: 'Rete Fornitori',
    description: 'Crea forti connessioni e fai crescere il tuo brand come parte del tuo flusso di lavoro. Raccogli i contatti dei fornitori, condividi le gallerie dei fornitori curate dall\'intelligenza artificiale e assicurati un uso corretto con termini di utilizzo allegati a ciascuna galleria.',
    cta: 'Scopri di più',
    galleryReady: 'LA TUA GALLERIA FORNITORE È PRONTA',
    viewGallery: 'VISUALIZZA GALLERIA',
    photos: 'foto',
  },
  
  // AI Search section
  aiSearch: {
    title: 'Ricerca Galleria con IA',
    description: 'La prossima generazione di consegna di gallerie professionali! Offri ai clienti la migliore esperienza con una barra di ricerca interattiva che consente loro di trovare rapidamente e facilmente i momenti preferiti con le persone che preferiscono.',
    cta: 'Scopri di più',
    searchPlaceholder: 'Cerca momenti...',
    peopleDetected: 'persone rilevate',
  },
  
  // Smart Store section
  smartStore: {
    title: 'Smart Store',
    description: 'Offri ai tuoi clienti una vasta gamma di articoli stampati di qualità, visualizzati in anteprima con le immagini con cui interagiscono di più nella loro galleria.',
    cta: 'Scopri di più',
    products: [
      { name: 'ALBUM LAY FLAT' },
      { name: 'CORNICI PASSEPARTOUT' },
      { name: 'CALENDARI' },
      { name: 'STAMPE' },
      { name: 'BOX STAMPE' },
      { name: 'BIGLIETTI AUGURI' },
    ],
  },
  
  // Print Labs section
  printLabs: {
    title: 'Laboratori di Stampa nel Mondo',
    description: 'Scegli tra i nostri partner internazionali di laboratori di stampa, perfettamente integrati nel tuo negozio.',
    cta: 'Scopri di più',
  },
  
  // Marketing Automation section
  marketingAutomation: {
    title: 'Automazione Marketing',
    description: 'Far sì che i propri clienti stampino le loro foto è un obiettivo importante per tutti i fotografi. Ciascuna delle nostre campagne preconfigurate include una serie di email e banner con sconti, progettati per entrare in contatto con i tuoi clienti e far crescere le vendite di stampa.',
    cta: 'Scopri di più',
    clickForSound: 'Clicca per l\'audio',
  },
  
  // Album Builder section
  albumBuilder: {
    title: 'Creatore di Album',
    description: 'Progetta, vendi e ordina gli album direttamente dalla galleria, oppure lascia che i tuoi clienti partecipino al processo di progettazione per renderlo ancora più semplice. Goditi un flusso di lavoro efficiente, dalla progettazione all\'ordine e alla spedizione.',
    cta: 'Scopri di più',
    includedInPro: 'Incluso nei piani Pro',
    albumOptions: [
      { name: 'Giorno del Matrimonio', count: 45 },
      { name: 'Momento di Festa', count: 32 },
      { name: 'Foto Nascoste', count: 18 },
      { name: 'I Miei Preferiti', count: 56 },
      { name: 'Album di Nozze', count: 40 },
    ],
  },
  
  // Slideshows section
  slideshows: {
    title: 'Slideshow',
    description: 'Eleva la tua consegna e crea un\'esperienza emozionale con gli Slideshow, integrati nelle nostre Gallerie Clienti. Usufruisci di una libreria musicale con licenza di oltre 1800 brani, tra cui l\'abbinamento automatico dei battiti e strumenti di progettazione avanzati.',
    cta: 'Esplora Slideshow',
    includedInPro: 'Incluso nei piani Pro',
    tracks: '1800+ brani',
    clickForSound: 'Clicca per l\'audio',
  },
  
  // Blogs section
  blogs: {
    title: 'Blog',
    description: 'Il nostro editor di blog è uno strumento di narrazione efficace creato per migliorare la tua presenza online come parte del tuo sito web o come pagina autonoma. Crea facilmente post di blog ottimizzati per SEO con strumenti di progettazione avanzati e promuovili sui social media.',
    cta: 'Esplora Blog',
    includedInPro: 'Incluso nei piani Pro',
    blogEditor: 'Editor Blog',
    seoOptimized: 'Ottimizzato SEO',
    clickForSound: 'Clicca per l\'audio',
  },
  
  // Art Galleries section
  artGalleries: {
    title: 'Gallerie d\'Arte',
    subtitle: 'Il tuo negozio online di mostre e stampe',
    includedInPro: 'Incluso nei piani Pro',
    cta: 'Esplora Gallerie d\'Arte',
    slides: [
      {
        title: 'Galleria d\'Arte & Store',
        description: 'Le Gallerie d\'Arte sono una piattaforma dedicata ai creativi con una serie di strumenti dedicati alla vendita di opere d\'arte, tra cui edizioni limitate, note video e audio, integrazione di laboratori in tutto il mondo e un\'automazione di marketing integrata.',
      },
      {
        title: 'Progetta il tuo Spazio',
        description: 'Le gallerie sono completamente personalizzabili in modo da poter far sentire la tua voce di artista. Inoltre, puoi esporre i tuoi prodotti in un ambiente interno in modo che i clienti possano visualizzare meglio le dimensioni e la sensazione del pezzo.',
      },
      {
        title: 'Consegna con Ordine Automatizzato',
        description: 'La nostra rete mondiale di laboratori di stampa offre un processo produttivo continuo, in cui i clienti possono ordinare e spedire in modo indipendente. Goditi una varietà di prodotti di stampa di qualità, dalle stampe fine art e cornici alle tele e stampe in metallo.',
      },
    ],
  },
  
  // CRM Integrations section
  crmIntegrations: {
    title: 'Integrazioni CRM',
    description: 'Abbiamo collaborato con diversi sistemi di gestione dello studio tra cui HoneyBook, Studio Ninja, Light Blue e Iris Works per integrare i nostri dati senza problemi. Gestisci, traccia e organizza facilmente le relazioni con i clienti e la contabilità per ottimizzare il tuo flusso di lavoro.',
    cta: 'Scopri di più',
  },
  
  // Migration section
  migration: {
    title: 'Trasferisci facilmente le tue Gallerie',
    description: 'Cambiare piattaforma è facile – il nostro team di migrazione lo fa per te! Il nostro team trasferirà tutte le tue foto e le informazioni sui clienti dal tuo attuale servizio di gallerie a Pic-Time.',
    cta: 'Scopri di più',
    migrationComplete: 'Migrazione Completata',
    photosTransferred: 'foto trasferite',
  },
  
  // CTA section
  cta: {
    title: 'Unisciti a Pic-Time Oggi',
    description: 'Prova il piano Avanzato di Pic-Time GRATIS per 30 giorni. Non è richiesta la carta di credito.',
    button: 'Inizia Gratis',
    noCreditCard: 'Nessuna carta di credito richiesta.',
  },
  
  // Login page
  login: {
    title: 'Accedi alla Galleria',
    subtitle: 'Inserisci le credenziali fornite dal fotografo',
    username: 'Username',
    password: 'Password',
    usernamePlaceholder: 'Inserisci username',
    passwordPlaceholder: 'Inserisci password',
    submit: 'Accedi',
    loading: 'Accesso in corso...',
    errorRequired: 'Inserisci username e password',
    backHome: '← Torna alla home',
  },
  
  // Footer
  footer: {
    product: {
      title: 'PRODOTTO',
      links: [
        { label: 'Negozio di Stampe', href: '#' },
        { label: 'Ricerca Gallerie IA', href: '#' },
        { label: 'Consegna Video', href: '#' },
        { label: 'Automazioni Vendita', href: '#' },
        { label: 'Gallerie di Campioni', href: '#' },
        { label: 'Gallerie d\'Arte', href: '#' },
        { label: 'Blog', href: '#' },
        { label: 'Slideshow', href: '#' },
      ],
    },
    resources: {
      title: 'RISORSE',
      links: [
        { label: 'Blog Pic-Time', href: '#' },
        { label: 'Migrazione Galleria', href: '#' },
        { label: 'Sistema Vendita Semplice', href: '#' },
        { label: 'Programma Affiliato', href: '#' },
        { label: 'Centro Assistenza', href: '#' },
        { label: 'Hub degli Esperti', href: '#' },
        { label: 'Webinar', href: '#' },
      ],
    },
    company: {
      title: 'AZIENDA',
      links: [
        { label: 'Prezzi', href: '#' },
        { label: 'Chi Siamo', href: '#' },
        { label: 'Carriera', href: '#' },
        { label: 'Contatti', href: '#' },
      ],
    },
    followUs: 'SEGUICI',
    copyright: '© 2025 Pic-Time, tutti i diritti riservati.',
    legal: [
      { label: 'Termini di Servizio', href: '#' },
      { label: 'Privacy Policy', href: '#' },
      { label: 'DPA', href: '#' },
      { label: 'CCPA', href: '#' },
      { label: 'Termini IA', href: '#' },
    ],
    downloadOn: 'Scarica su',
    appStore: 'App Store',
    getItOn: 'Disponibile su',
    googlePlay: 'Google Play',
  },
};
